import {UserPermissions} from './user-permissions.model';
import {UserSetting} from './user-setting.model';

export class TorchUser {
  id: number;
  username: string;
  displayName: string;
  givenName: string;
  surname: string;
  nickname: string;
  employeeId: string;
  role: string;
  effectiveRole: string;
  isCRT: boolean;
  department: string;
  jobTitle: string;
  enteredAt: string;
  enteredBy: string;
  updatedAt: string;
  updatedBy: string;
  loginDatetime: string;
  businessPhoneNumbers: string[];
  city: string;
  companyName: string;
  country: string;
  emailAddress: string;
  workAddress: string;
  manager?:  {
    fullName: string;
    emailAddress: string;
  };
  permissions: UserPermissions[];
  roles: string[];
  settings?: UserSetting[];
}
